module.exports = __webpack_public_path__ + "img/clock_paused.07c5d339.svg";